// src/pages/Onboard/index.jsx
import React, { useState } from "react";
import StepEligibility from "./StepEligibility";
import StepWorkStatus from "./StepWorkStatus";
import StepEmailVerification from "./StepEmailVerification";
import CreateAccount from "./CreateAccount"; // your existing form (kept)
import StepFinal from "./StepFinal";

import "./onboard.css";


export default function OnboardWizard() {
  const totalSteps = 5; // 1 Eligibility, 3 Work, 4 Email, 5 Create
  const [step, setStep] = useState(1);

  const [authority, setAuthority] = useState("");
  const [covered, setCovered] = useState(null);
  const [postcode, setPostcode] = useState("");
  const [email, setEmail] = useState("");
  const [emailToken, setEmailToken] = useState("");

  return (
    <div className="dashboard-content">
      {step === 1 && (
        <StepEligibility
          totalSteps={totalSteps}
          setAuthority={setAuthority}
          setCovered={setCovered}
          setPostcode={setPostcode}
          onEligible={() => setStep(3)} // 2 would be a congrats splash; we rolled it into messages for simplicity
        />
      )}

      {step === 3 && (
        <StepWorkStatus
          totalSteps={totalSteps}
          onPass={() => setStep(4)}
        />
      )}

      {step === 4 && (
        <StepEmailVerification
          totalSteps={totalSteps}
          postcode={postcode}
          covered={covered}
          onVerified={({ email_token, email }) => {
            setEmailToken(email_token);
            setEmail(email);
            setStep(5);
          }}
        />
      )}

      {step === 5 && (
        <CreateAccount
          email_token={emailToken}
          email={email}
          authority_name={authority}
          onDone={() => setStep(6)}
        />
      )}

      {step === 6 && <StepFinal name="" />}
    </div>
  );
}

